import { render, staticRenderFns } from "./exportorder.vue?vue&type=template&id=53c992b8&scoped=true"
import script from "./exportorder.vue?vue&type=script&lang=js"
export * from "./exportorder.vue?vue&type=script&lang=js"
import style0 from "./exportorder.vue?vue&type=style&index=0&id=53c992b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c992b8",
  null
  
)

export default component.exports